exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.PolarisVue-FadeUpTransition--show {\n  transition: opacity 0.5s, transform 0.5s;\n}\n.PolarisVue-FadeUpTransition--hide {\n  opacity: 0;\n  transform: translateY(30px);\n}\n", "", {"version":3,"sources":["/home/kiran-price/_polaris_vue/live/src/components/transitions/FadeUpTransition.vue"],"names":[],"mappings":";AAAA;EACE,yCAAyC;CAAE;AAE7C;EACE,WAAW;EACX,4BAA4B;CAAE","file":"FadeUpTransition.vue","sourcesContent":[".PolarisVue-FadeUpTransition--show {\n  transition: opacity 0.5s, transform 0.5s; }\n\n.PolarisVue-FadeUpTransition--hide {\n  opacity: 0;\n  transform: translateY(30px); }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-76fc7556","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/transitions/FadeUpTransition.vue
// module id = 367
// module chunks = 0